// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IVoidDecision
 */
export interface IVoidDecision {
    /**
     * 
     * @type {string}
     * @memberof IVoidDecision
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof IVoidDecision
     */
    reason?: string;
}

/**
 * Check if a given object implements the IVoidDecision interface.
 */
export function instanceOfIVoidDecision(value: object): value is IVoidDecision {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function IVoidDecisionFromJSON(json: any): IVoidDecision {
    return IVoidDecisionFromJSONTyped(json, false);
}

export function IVoidDecisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): IVoidDecision {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function IVoidDecisionToJSON(json: any): IVoidDecision {
    return IVoidDecisionToJSONTyped(json, false);
}

export function IVoidDecisionToJSONTyped(value?: IVoidDecision | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'reason': value['reason'],
    };
}

